import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { toast } from "sonner";
import { subscribeUpdate, applyUpdate, checkForUpdate } from "@/lib/pwa";

// Mounted once inside the router: re-checks for a new build on every route change and shows a persistent "Reload" toast when one is ready.
export default function UpdatePrompt() {
  const { pathname } = useLocation();
  const shown = useRef(false);
  useEffect(() => { checkForUpdate(); }, [pathname]);
  useEffect(() => subscribeUpdate((ready) => {
    if (!ready || shown.current) return;
    shown.current = true;
    toast("A new version of ChangeOS is ready", {
      id: "app-update", duration: Infinity, description: "Reload to pick up the latest fixes. Anything you've saved is safe.",
      action: { label: "Reload", onClick: () => applyUpdate() },
    });
  }), []);
  return null;
}
